var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C9.48611 0 5 4.48611 5 10C5 11.6553 5.41385 13.2965 6.20059 14.7522L14.4532 29.6777C14.563 29.8767 14.7724 30 15 30C15.2277 30 15.437 29.8767 15.5469 29.6777L23.8025 14.7473C24.5862 13.2965 25 11.6552 25 9.99996C25 4.48611 20.5139 0 15 0ZM15 15C12.2431 15 10 12.757 10 10C10 7.24307 12.2431 5.00004 15 5.00004C17.757 5.00004 20 7.24307 20 10C20 12.757 17.757 15 15 15Z",
    fill: "#843939"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinContact);
export default __webpack_public_path__ + "static/media/pin-contact.678a9159.svg";
export { ForwardRef as ReactComponent };